module.exports = __webpack_public_path__ + "img/矿山banner1.15ac6cd8.png";